import moment from 'moment';

export const DATE_FORMAT_MDY = 'MM-DD-YYYY';
export const DATE_FORMAT_YMD = 'YYYY-MM-DD';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_TIME = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_TIMESTAMP = 'DDMMYYYYHHmm';

export function formatDateMDY(value) {
    if (value) {
        return moment(String(value)).format(DATE_FORMAT_MDY);
    }
}

export function formatDateYMD(value) {
    if (value) {
        return moment(String(value)).format(DATE_FORMAT_YMD);
    }
}

export function formatDate(value) {
    if (value) {
        return moment(String(value)).format(DATE_FORMAT);
    }
}




export function formatDateTime(value) {
    if (value) {
        return moment(String(value)).format(DATE_FORMAT_TIME);
    }
}
// get timestamp 
export function formatDateTimestamp() {
    return new Date().getTime();
}

export function currentDate() {
    return moment(new Date()).format(DATE_FORMAT);
}

export function currentDateTime() {
    return moment(new Date()).format(DATE_FORMAT_TIME);
}



export function addMn(date, mn) {
    if (date && mn) {
        return moment(date).add('m', mn);
    }
}